import './assets/main.css'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import appInsightsPlugin from './plugin/app-insights/app-insights-plugin'
import { initalizeAzureADAsync } from '@/features/auth/azure-ad'
import appProvidePlugin from '@/plugin/app-provide/app-provide-plugin'
import { vFocusable, vEnvironnement } from './directives'
import { createEventBus } from './plugin/event-bus/createEventBus'
import type { AppBusEvents } from '@/features/application/app-events'
import { SnackbarService } from 'vue3-snackbar'
import { RegistrationDSComponents } from '@/plugin/registration'
import { deviceBreakpointPlugin } from '@/plugin/device-breakpoint'

initalizeAzureADAsync().then(() => {
  const app = createApp(App)
  app.use(createEventBus<AppBusEvents>())
  app.use(SnackbarService)
  app.use(RegistrationDSComponents)
  app.use(createPinia())
  app.use(appProvidePlugin)
  app.use(appInsightsPlugin, { router })
  app.use(router)
  app.use(deviceBreakpointPlugin)
  app.directive('focusable', vFocusable)
  app.directive('environnement', vEnvironnement)
  app.mount('#app')
})
